export default {
  title: 'Register',
  type: 'object',
  properties: {
    termsIds: {
      type: 'array',
      items: {
        type: 'number'
      },
      validFunc: '$external.requiredLength === $value.length',
      validationMessages: {
        validFunc: 'Pole wymagane'
      }
    },
    profile: {
      title: 'Profil',
      type: 'object',
      properties: {
        lang: {
          title: 'schema.profile.lang',
          type: 'string',
          fieldRequired: true
        },
        email: {
          title: 'schema.profile.email',
          type: 'string',
          format: 'email',
          fieldRequired: true
        },
        firstName: {
          title: 'schema.profile.firstName',
          type: 'string',
          fieldRequired: true
        },
        lastName: {
          title: 'schema.profile.lastName',
          type: 'string',
          fieldRequired: true
        },
        phoneNumber: {
          title: 'schema.profile.phoneNumber',
          type: 'string',
          fieldRequired: false
        },
        birthDate: {
          title: 'schema.profile.birthDate',
          type: 'string',
          format: 'date',
          fieldRequired: true
        }
      }
    }
  }
};
